<template>
  <div class="padding-five-lr" style="background: #f8f8f8">
    <div>
      <b-row style="max-width: 100%" class="padding-ten-tb">
        <b-col xs="12" sm="12" md="12" lg="4">
          <h5 class="color-gray">Servicios</h5>
        </b-col>
      </b-row>
    </div>
    <div class="bg-white padding-five-all">
      <h5 class="color-orange">Búsqueda</h5>
      <b-container fluid>
        <b-row class="padding-ten-tb">
          <b-col cols="12" sm="9" md="4" lg="5" class="padding-two-bottom-xs">
            <label class="text-grey">Sku</label>
            <b-form-input
              type="text"
              v-on:keyup.enter="searchSkuService"
              v-model="skuService"
              placeholder="Ingresa el valor"
            ></b-form-input>
          </b-col>
          <b-col
            xs="12"
            sm="12"
            md="12"
            lg="4"
            class="align-bottom text-left-xs"
          >
            <b-button
             
              @click="searchSkuService"
              class="bg-orange-btn width-1000"
            >
              <font-awesome-icon icon="search" /> Buscar
            </b-button>
            <b-button
              class="bg-grey-btn hidden-icon padding-six-right"
              @click="clearValues"
            >
              <font-awesome-icon icon="broom" s /> Limpiar
            </b-button>
          </b-col>
          <b-col
            xs="12"
            sm="12"
            md="12"
            lg="3"
            class="align-bottom-end text-right text-left-xs"
          >
            <b-button
              class="bg-orange-btn width-1000"
              v-b-modal.modal-registrar-serv
            >
              <font-awesome-icon icon="plus" /> Agregar
            </b-button>
            <b-modal
              hide-footer
              id="modal-registrar-serv"
              title="Datos del servicio"
            >
              <register-service> </register-service>
            </b-modal>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="bg-white padding-five-all">
      <b-container fluid>
        <b-row>
          <b-col cols="12">
            <h5 class="color-orange">Resultados</h5>
          </b-col>
        </b-row>
        <b-table
          class="hidden-xs"
          show-empty
          small
          :busy="isBusy"
          striped
          :items="listServices"
          :fields="fields"
          :current-page="currentPage"
          :per-page="0"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <b-row>
              <b-col cols="12" md="auto">
                <b-button
                  size="sm"
                  @click="setDataSelected(row.item)"
                  class="mr-1 btn-rounded-orange border-none"
                  >EDITAR
                </b-button>
              </b-col>
              <b-col cols="12" md="auto">
                <b-button
                  size="sm"
                  v-if="row.item.active"
                  @click="deleteService(row.item, $event.target)"
                  class="mr-1 btn-rounded-red border-none"
                  >INACTIVAR
                </b-button>
                <b-button
                  size="sm"
                  v-else
                  @click="activateService(row.item, $event.target)"
                  class="mr-1 btn-rounded-red border-none"
                  >ACTIVAR
                </b-button>
              </b-col>
            </b-row>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalServices"
          :per-page="perPage"
          pills
          align="center"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-container>
    </div>
    <div>
      <b-modal
        @hidden="onHidden"
        v-model="showModalEditSku"
        centered
        hide-footer
        id="modal-editar-serv"
        title="Datos del servicio"
      >
        <edit-services
          :description.sync="description"
          :company.sync="company"
          :sku.sync="sku"
          v-model="beetrack"
          :showModalEditSku.sync="showModalEditSku"
        >
        </edit-services>
      </b-modal>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import RegisterService from "../../components/Servicios/RegisterService.vue";
import EditServices from "../../components/Servicios/EditServices.vue";
import { mapState } from "vuex";
export default {
  components: { RegisterService, EditServices },
  name: "Servicios",
  data() {
    return {
      
      beetrack:false,
      sku:"",
      description:"",
      company:"",
      showModalEditSku: false,
      selectedData: { sku: "", description: "" },
      skuService: "",
      sortBy: "",
      currentPage: 1,
      perPage: 10,
      selectedFilter: "a",
      documentValue: "",
      providers: [],
      fields: [
        {
          key: "sku",
          label: "SKU",
        },
        {
          key: "description",
          label: "Descripción",
        },
        {
          key: "company",
          label: "Empresa",
        },
        { key: "actions", label: "" },
      ],
      isBusy: false,
      listServices: [],
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      totalItems: 0,
    };
  },
  computed: {
    ...mapState("module", ["options","token"]),
    optionCreate() {
      //id 16 Crear
      return this.options.some((m) => m.id == 16);
    },
    optionEdit() {
      //id 17 Editar
      return this.options.some((m) => m.id == 17);
    },
    optionInactive() {
      //id 20 Inactivar
      return this.options.some((m) => m.id == 20);
    },
    totalServices() {
      if (this.currentPage == 1 && this.listServices.length < 10) return 10;
      return 500;
    },
  },
  mounted() {
    // this.searchSkuService();
    //this.getTotal();
  },
  watch: {
    currentPage: {
      handler: function () {
        this.searchSkuService().catch((error) => {
          console.error(error);
        });
      },
    },
  },
  methods: {
    onHidden() {
      this.sku="";
      this.description="";
      this.beetrack=false;
    },
    async deleteService(item) {
      try {
       
        this.$store.commit("SET_LOADING", true);
        let response = await axios.delete(
          process.env.VUE_APP_SERVICES_CORE_BASE + "/services/" + item.sku,
          {
              headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer "+ this.token
              },
          }
        );
        console.log(response);

        let values = {
          variant: "success",
          msg: "Se ha inactivado exitosamente !",
        };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        this.searchSkuService();
        //this.providers = response.data;
      } catch (error) {
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        this.$store.commit("SET_LOADING", false);
        
      }
    },
    async activateService(item) {
      try {
        
       
        this.$store.commit("SET_LOADING", true);
        let response = await axios.put(
          process.env.VUE_APP_SERVICES_CORE_BASE + "/services/" + item.sku,
          {
            
            description: item.description,
            sku: item.sku,
            active: true,
            beetrack: item.beetrack,
            dimensioned: item.dimensioned,
            group: item.group
          },
          {
              headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer "+ this.token
              },
          }
        );
        console.log(response);

        let values = {
          variant: "success",
          msg: "Se ha inactivado exitosamente !",
        };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
        this.searchSkuService();
        //this.providers = response.data;
      } catch (error) {
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        this.$store.commit("SET_LOADING", false);
        
      }
    },
    clearValues() {
      this.skuService = "";
    },
    async searchSkuService() {
      try {
        this.isBusy = true;
        let response = await axios.get(
          process.env.VUE_APP_SERVICES_CORE_BASE +
            "/services?ids=" +
            this.skuService +
            "&limit=" +
            this.perPage +
            "&page=" +
            this.currentPage +
            "&state=ALL&pageable=true",
            {
              headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer "+ this.token
              },
          }
        );

        this.listServices = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    setDataSelected(item) {
      this.sku=item.sku;
      this.description=item.description;
      this.showModalEditSku = true;
      this.beetrack=item.beetrack;
      this.company=item.company;
     
    },
  },
};
</script>
<style scoped>
::v-deep .page-item.active .page-link {
  background: #ff7a00;
  color: white;
  border-color: transparent;
}
::v-deep .page-item.disabled .page-link {
  background: transparent !important;
  border-color: transparent !important;
  color: #ff7a00;
}
::v-deep .page-link {
  color: #676767;
  border-color: transparent;
  font-weight: bold;
  background: transparent;
}

.padding-ten-lr {
  padding: 10px;
  padding-left: 35px !important;
}
.color-gray {
  color: #676767;
  font-weight: bold;
}

.color-orange {
  color: #ff7a00;
}

.btn-orange-tra {
  border-radius: 50%;
}
.bg-grey {
  background-color: #ececec;
  border-color: transparent;
  color: #bbbbbb;
}

.bg-grey-btn {
  background-color: #676767;
  border-radius: 20px;
}
::v-deep .modal-title {
  color: #ff7a00 !important;
  font-weight: 500;
}
::v-deep .modal-header {
  border-bottom: none;
}

.padding-six-right {
  margin-left: 20px;
}
::v-deep .b-table thead {
  background-color: transparent !important;
  color: black !important;
  font-weight: 500 !important;
  border: none !important;
}
::v-deep .table tr:first-child td {
  border-top: 1px solid transparent !important;
}
::v-deep .b-table thead th {
  font-weight: 700 !important;
  border: none !important;
  font-size: 11pt;
}
::v-deep .table td {
  color: black;
  font-size: 11pt;
}
::v-deep .table-striped tbody tr:nth-of-type(odd) {
  background-color: transparent;
}
.align-bottom {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.align-bottom-end {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
</style>
